export default (packages, dataForm) => ({
  additionalPackagingGroup: [
    {
      validator: (rule, value, callback) => {
        const packagings = dataForm.services.typeOfPackagings.value;
        if (!packagings || packagings.length === 0) {
          callback();
          return;
        }
        const requiredItems = packagings.filter(el => el.isRequired);
        if (requiredItems.length === 0) {
          callback();
          return;
        }
        const missingItems = requiredItems.filter(el => !value.includes(el.title));
        if (missingItems.length > 0) {
          callback(new Error(`Необходимо выбрать обязательные упаковки: ${missingItems.map(el => el.title).join(', ')}`));
          return;
        }
        callback();
      },
      trigger: 'change',
    },
  ],
});
